export class AutorizacionSeguro {
    idAutorizacionSeguro: number;
    idEmpleado: number;
    fechaAutorizacion: Date;
    observaciones: string;
    totalAutorizado: number;
    status: string;
    idValeManoObra: number;
    idValeRefaccion: number;
    idValuacionGeneral: number;
    idDeducible: number;
    idDemerito: number;
    idValeComplemento: number;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/autorizacionSeguro.ts